import React, { useState, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Icon, Form, Button, Loader } from "semantic-ui-react";
import { createGauranteeInfo } from "../../actions";
import GuaranteeForm from "./guaranteeForm";

function GuaranteeDetails(props) {
  const [isAdding, setIsAdding] = useState(false);
  const dispatch = useDispatch();



  const updateAddStatus = useCallback(() => {
    setIsAdding(false);
  },[isAdding])

  const { isFormDisabled, translate} = props;

  return (
 
    <Form.Group className="float-container">
          <div
          style={{
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          <strong>{translate("GUARANTEE_DETAIL",{ns:["default","parties"]})}</strong>
        </div>
        <GuaranteeForm
          isFormDisabled={isFormDisabled}
          translate={translate}
        />

        <Button
          id="addGrn"
          basic
          color="blue"
          className="btn-add"
          onClick={() => {
            setIsAdding(true);
            dispatch(createGauranteeInfo(updateAddStatus));
          }}
          disabled={isFormDisabled || isAdding}
        >
          {!isAdding ? (
            <span>
              <Icon
                name="plus square alternate outline"
                disabled={isFormDisabled}
              />{" "}
              {translate("ADD",{ns:["default","parties"]})}
            </span>
          ) : (
            <span>
              <Loader
                active
                inline
                size="mini"
                style={{ marginRight: "10px" }}
              />
              {translate("ADDING",{ns:["default","parties"]})}..
            </span>
          )}
        </Button>

 
      </Form.Group>
   
  );
}

export default React.memo(GuaranteeDetails)
